<script>
  import { getContext } from "svelte";
  import { activePlanet, showPopup } from "../stores/global.js";
  import fx from "../actions/fx.js";
  import Charts from "./UI.Popup.Charts.svelte";
  import Icon from "./helpers/Icon.svelte";
  import spritesheet from "../data/spritesheet.csv";
  const { shows } = getContext("App");

  $: visible = !!$showPopup;
  $: showIndex = shows.findIndex((s) => s.index === $showPopup);

  $: if (
    visible &&
    showIndex > -1 &&
    typeof window !== undefined &&
    window.gtag
  ) {
    gtag("event", "show-bubble", {
      event_category: "show-genre",
      event_label: "show-name",
      value: shows[showIndex].title,
    });
  }

  const getUrl = (sheet) => {
    return `assets/sprite/spritesheet-${sheet.sheet}@2x.jpg`;
  };

  const getPos = (sheet) => {
    const x = (100 / (+sheet.w - 1)) * +sheet.x;
    const y = (100 / (+sheet.h - 1)) * +sheet.y;
    return `${x}% ${y}%`;
  };

  const getSize = (sheet) => {
    return `${+sheet.w * 100}% ${+sheet.h * 100}%`;
  };

  const getStyle = (show) => {
    const sheet = spritesheet.find((s) => s.slug === show.slug);
    if (sheet) {
      const u = `background-image: url(${getUrl(sheet)});`;
      const p = `background-position: ${getPos(sheet)};`;
      const s = `background-size: ${getSize(sheet)};`;
      return `${u} ${p} ${s}`;
    }
    return "";
  };

  const onClose = () => ($showPopup = false);
</script>

<div id="popup" class="bg" class:visible>
  <div class="popup">
    <button class="icon" on:click="{onClose}" use:fx><Icon name="x" /></button>
    {#each shows as show, i}
      <div class="inner" class:active="{i === showIndex}">
        <div class="top">
          <div class="cover" style="{getStyle(show)}"></div>
          <h3 class="title">{show.titleHostless}</h3>
          {#if show.hosts}
            <p class="host">{show.hosts.replace(/\|/g, ", ")}</p>
          {/if}
        </div>
        <div class="bottom">
          <p>{show.description}</p>
          <Charts show="{show}" />
        </div>
      </div>
    {/each}
  </div>
</div>

<style>
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: rgba(50, 50, 50, 0.33);
    opacity: 0;
    backdrop-filter: blur(4px) grayscale(75%);
    transition: all 0.25s ease-out;
    z-index: var(--z-overlay);
  }

  .bg.visible {
    opacity: 1;
  }

  .popup {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: var(--z-overlay);
    background: var(--base-white);
    color: var(--base-black);
    transform: translateX(100%);
    transition: all 0.25s ease-out;
    max-width: 25em;
  }

  .bg.visible .popup {
    transform: translateX(0);
  }

  .inner {
    overflow-y: auto;
    pointer-events: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
  }

  button.icon {
    display: flex;
    position: absolute;
    top: 0.5rem;
    left: -0.5rem;
    line-height: 1;
    transform: translate(-100%, 0);
    color: white;
    pointer-events: auto;
    border: 1px dashed var(--base-white);
    border-radius: 50%;
    align-items: center;
    text-align: center;
  }

  .top {
    background-color: var(--base-gray-dark);
    padding: 1em;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .bottom {
    padding: 1.5rem;
  }

  .bottom p {
    font-size: 16px;
  }

  .cover {
    width: 6em;
    height: 6em;
    flex-grow: 1;
    margin: 1em 0;
    /* background-size: 25% 25%; */
  }

  .title {
    margin: 0 auto;
    color: var(--base-white);
    font-weight: bold;
    max-width: 10em;
    font-size: 28px;
  }

  .host {
    color: var(--theme);
    margin: 0;
    margin-top: 0.5em;
    line-height: 1.2;
  }

  .active {
    display: block;
  }

  @media only screen and (max-width: 640px) {
    button.icon {
      left: auto;
      right: 0.5rem;
      transform: translate(0, 0);
      z-index: var(--z-overlay);
    }
  }
</style>
